exports.sendWasmWorkerRequest_ = (request) => () => {
  window.wasmWorker.postMessage(request);
};
